import { API_AUTH } from "./common";

const OrderApi = {
    getThongTinDonHang: (OrderID) =>
        API_AUTH.get(`QuanLyMuaBan/Order/GetThongTinDonHang?orderID=${OrderID}`),
};


export default OrderApi;